<template>
  <v-btn color="var(--primary-blue-10)" data-analytics-skip style="font-size: 12px; font-weight: 600; color: deepblue" depressed
    @click="$emit('click')">
    <mrx-translation token="app.inputs.unknown.button"></mrx-translation>
  </v-btn>
</template>

<script>
export default {
  name: 'UnknownButton',
}
</script>
